//#region src/config/apply.ts
async function applyConfig(env) {
	switch (env) {
		case "dev":
			await import("./env-dev.js");
			break;
		case "stg":
			await import("./env-stg.js");
			break;
		case "prd":
			await import("./env-prd.js");
			break;
	}
}

//#endregion
export { applyConfig };